export default __webpack_public_path__ + "static/media/fire-protection.8ed1bac3.jpg";